module.exports = __webpack_public_path__ + "media/images/bar-a8f01f06b73c9b67dd3f2c411aa63fa1.svg";